import { Component, Input } from "@angular/core";
import moment from "moment";

@Component({
  selector: "medication-history",
  templateUrl: "medication-history.html",
})
export class MedicationHistoryComponent {
  expanded: boolean = false;

  @Input() date: string;

  @Input() data: any;

  sample = {
    submittedBy: "Mary Myers: 02/08/18 13:00 CST",
    approvedBy: "John Ables: 02/08/18 15:00 CST",
    category: "Neurological",
    issue: "Agitation",
    name: "Ativan (Lorazepam) 5mg",
    dosage: "2 times every 3 Days",
    dosageParams: "Parameters",
    route: "Oral",
    frequency: "2 times daily (b.i.d.)",
    startDate: "01/01/2019",
    dcDate: "02/02/2019",
    physician: { displayName: "Dr. Mario" },
    physicianOrder: "Verbal",
    hospicePays: "No",
    administeredBy: "Hospice",
    teachingsPerformed: "Yes",
  };

  // medications = [
  //   { name: "Morphine Sulfate (Roxanel)",
  //     records: [
  //       {
  //         time: '8:15am',
  //         dosage: '000',
  //         administrator: 'Cindy Lane',
  //         administered: true
  //       },
  //       {
  //         time: '9:00am',
  //         dosage: '001',
  //         administrator: 'Cindy Lane',
  //         administered: true
  //       },
  //       {
  //         time: '9:45am',
  //         dosage: '002',
  //         administrator: 'Cindy',
  //         administered: true
  //       },
  //       {
  //         time: '9:50am',
  //         dosage: '003',
  //         administrator: 'Not testtestetestsetalskdfjals;kdfj;aslkfdj;aslkdjf;laskjdf',
  //         administered: true
  //       },
  //       {
  //         time: '10:30am',
  //         administered: false
  //       },
  //       {
  //         time: '12:12pm',
  //         dosage: '002',
  //         administrator: 'Cindy Lane',
  //         administered: true
  //       },
  //       {
  //         time: '11:15am',
  //         administered: false
  //       },
  //       {
  //         time: '12:12pm',
  //         dosage: '002',
  //         administrator: 'Cindy Lane',
  //         administered: true
  //       },
  //       {
  //         time: '8:15am',
  //         dosage: '000',
  //         administrator: 'Cindy Lane',
  //         administered: true
  //       },
  //       {
  //         time: '9:00am',
  //         dosage: '001',
  //         administrator: 'Cindy Lane',
  //         administered: true
  //       },
  //       {
  //         time: '9:45am',
  //         dosage: '002',
  //         administrator: 'Cindy',
  //         administered: true
  //       },
  //       {
  //         time: '9:50am',
  //         dosage: '003',
  //         administrator: 'Not testtestetestsetalskdfjals;kdfj;aslkfdj;aslkdjf;laskjdf',
  //         administered: true
  //       },
  //     ]
  //   },
  //   {
  //     name: "Morphine Sulfate (Roxanel)",
  //     records: [
  //       {
  //         time: '8:15am',
  //         dosage: '000',
  //         administrator: 'Cindy Lane',
  //         administered: true
  //       },
  //       {
  //         time: '9:00am',
  //         dosage: '001',
  //         administrator: 'Cindy Lane',
  //         administered: true
  //       },
  //       {
  //         time: '9:45am',
  //         dosage: '002',
  //         administrator: 'Cindy',
  //         administered: true
  //       }
  //     ]
  //   },
  //   {
  //     name: "Diazepam Tablets Valium",
  //     records: [
  //       {
  //         time: '8:15am',
  //         dosage: '000',
  //         administrator: 'Cindy Lane',
  //         administered: true
  //       },
  //       {
  //         time: '10:30am',
  //         administered: false
  //       },
  //       {
  //         time: '9:45am',
  //         dosage: '002',
  //         administrator: 'Cindy',
  //         administered: true
  //       },
  //       {
  //         time: '9:45am',
  //         dosage: '002',
  //         administrator: 'Cindy',
  //         administered: true
  //       }
  //     ]
  //   }
  // ];

  selectedMedicationData: any = null;

  constructor() {}

  selectMedication(event) {
    console.log(event);
    this.selectedMedicationData = event.selected;
  }

  convertDateToDOW(date) {
    return moment(date).format("dddd");
  }
}



// WEBPACK FOOTER //
// ./src/components/medication-administration-records/medication-history/medication-history.ts